import gql from 'graphql-tag';

export const getQuantityWaitlistQuery = gql(/* GraphQL */ `
  query getQuantityWaitlist(
    $pagination: PaginationInput
    $contentId: UUID!
    $channelId: UUID!
    $search: QuantityWaitlistSearch
  ) {
    quantityWaitlistForAdmin(
      contentId: $contentId
      channelId: $channelId
      pagination: $pagination
      search: $search
    ) {
      items {
        id
        createdAt
        startDate
        endDate
        user {
          name
          email
        }
        companyName
      }
      pageInfo {
        start
        perPage
        total
      }
    }
  }
`);
